import { Breakpoints } from '@lichtblick/theme';
import { Box } from '@lichtblick/ui-components';
import styled from 'styled-components';
export const Container = styled(Box)`
  margin: 0 auto;
  max-width: ${({ $maxWidth })=>$maxWidth ? `${$maxWidth}px` : `${Breakpoints.Medium}px`};
`;

//# sourceMappingURL=Container.js.map